import { useEffect, useState } from "react";
import { Swords } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function WanderingVeteranPanel() {
  const [ev, setEv] = useState(null);
  const [veteran, setVeteran] = useState("Flamma");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/wandering-veteran").then((r) => {
    setEv(r.data);
    if (r.data.veteran) setVeteran(r.data.veteran);
  }).catch(() => setEv(null));
  useEffect(() => { load(); }, []);
  const toggle = async (action) => {
    setBusy(true);
    try {
      const r = await api.post("/admin/wandering-veteran", { action, veteran });
      setEv((p) => ({ ...(p || {}), ...r.data, veterans: p?.veterans }));
      toast.success(action === "start" ? `${veteran} has arrived — event runs 7 days!` : "Wandering Veteran has moved on.");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const active = ev?.active;
  const veterans = ev?.veterans || ["Flamma", "Spartacus", "Priscus", "Verus", "Crixus", "Carpophorus"];
  return (
    <div data-testid="wandering-veteran-panel" className="mb-6 border border-stone-700/60 bg-gradient-to-br from-stone-900/40 to-zinc-950 p-4 rounded-sm">
      <div className="flex items-center gap-2 mb-3">
        <Swords size={16} className="text-stone-300" />
        <h3 className="font-cinzel text-stone-200 uppercase tracking-widest text-sm">Wandering Veteran Event</h3>
      </div>
      <div className="flex flex-wrap items-end gap-3">
        <p className="text-sm text-zinc-500 flex-1 min-w-[220px]">
          {active ? <span className="text-emerald-300">Active — {ev?.veteran}</span> : "Inactive"} — a legendary gladiator visits for 7 days. Players lock in one gladiator and pay favor daily (a ranked fight) for +50% training in a skill of their choosing.
          {active && ev?.ends_at ? <span className="text-zinc-500"> Ends {new Date(ev.ends_at).toLocaleString()}.</span> : null}
        </p>
        {!active && (
          <div>
            <label className="block text-[11px] uppercase tracking-widest text-zinc-500 mb-1">Veteran</label>
            <select data-testid="wandering-veteran-select" value={veteran} onChange={(e) => setVeteran(e.target.value)}
              className="bg-zinc-900 border border-zinc-800 px-3 py-2 text-zinc-100 text-sm focus:border-stone-500 outline-none rounded-sm">
              {veterans.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
        )}
        {active ? (
          <button data-testid="wandering-veteran-stop" onClick={() => toggle("stop")} disabled={busy}
            className="px-5 py-2 border border-stone-700/60 text-stone-300 hover:border-stone-400 font-cinzel uppercase tracking-wide text-sm rounded-sm disabled:opacity-50">End Event</button>
        ) : (
          <button data-testid="wandering-veteran-start" onClick={() => toggle("start")} disabled={busy}
            className="px-5 py-2 bg-stone-600 text-white font-cinzel uppercase tracking-wide text-sm hover:bg-stone-500 rounded-sm disabled:opacity-50">Start Event</button>
        )}
      </div>
    </div>
  );
}
